import {Action, ActionReducerMap} from '@ngrx/store';
import * as actionsUi from './qs-checks-controlling-veranstaltung.actions.ui';
import {
    GET_VERANSTALTUNG_UEBERSICHT,
    GET_VERANSTALTUNG_UEBERSICHT_ERFOLGREICH,
    GET_VERANSTALTUNG_UEBERSICHT_FEHLER, GET_PRUEFLAUF_CONTROLLING, GET_PRUEFLAUF_CONTROLLING_ERFOLGREICH, GET_PRUEFLAUF_CONTROLLING_FEHLER,
    GetVeranstaltungUebersichtErfolgreichAction, GetPrueflaufControllingErfolgreichAction, POST_PRUEFLAUF_LOESCHEN, PostPrueflaufLoeschenAction
} from '../../../../client-ngrx/qschecks';
import {Pruefaufgabe, Prueflauf, PrueflaufAufgabe, PrueflaufDetail, VeranstaltungUebersicht} from '../../../../clients/qschecks';
import {AKTUELLE_PRUEFAUFGABE_SETZEN, AKTUELLEN_PRUEFLAUF_ENTFERNEN, AKTUELLEN_PRUEFLAUF_SETZEN, AktuellenPrueflaufSetzenAction, AktuellePruefaufgabeSetzenAction} from './qs-checks-controlling-veranstaltung.actions.ui';

export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};


export interface PageState {
    veranstaltungUebersichtLaden: boolean;
    veranstaltungUebersichtFehler: boolean;
    veranstaltungUebersicht: VeranstaltungUebersicht;

    aktuellerPrueflauf: Prueflauf;

    prueflaufDetail: PrueflaufDetail;
    prueflaufDetailLaden: boolean;
    prueflaufDetailFehler: boolean;

    aktuellePruefaufgabe: PrueflaufAufgabe;
}

export const initialPageState: PageState = {
    veranstaltungUebersichtLaden: false,
    veranstaltungUebersichtFehler: false,
    veranstaltungUebersicht: null,

    aktuellerPrueflauf: null,

    prueflaufDetail: null,
    prueflaufDetailLaden: false,
    prueflaufDetailFehler: false,

    aktuellePruefaufgabe: null
};


export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // APP RESET
        case actionsUi.PAGE_STATE_RESET: {
            return Object.assign({}, state, <PageState>initialPageState);
        }

        case GET_VERANSTALTUNG_UEBERSICHT: {
            return Object.assign({}, state, <PageState>{
                veranstaltungUebersichtLaden: true,
                veranstaltungUebersichtFehler: false
            });
        }

        case GET_VERANSTALTUNG_UEBERSICHT_ERFOLGREICH: {
            const a = <GetVeranstaltungUebersichtErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                veranstaltungUebersichtLaden: false,
                veranstaltungUebersichtFehler: false,
                veranstaltungUebersicht: a.payload
            });
        }

        case GET_VERANSTALTUNG_UEBERSICHT_FEHLER: {
            return Object.assign({}, state, <PageState>{
                veranstaltungUebersichtLaden: false,
                veranstaltungUebersichtFehler: true,
                veranstaltungUebersicht: null
            });
        }

        case AKTUELLEN_PRUEFLAUF_SETZEN: {
            const a = <AktuellenPrueflaufSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                aktuellerPrueflauf: a.payload
            });
        }

        case GET_PRUEFLAUF_CONTROLLING: {
            return Object.assign({}, state, <PageState>{
                prueflaufDetailLaden: true,
                prueflaufDetailFehler: false
            });
        }

        case GET_PRUEFLAUF_CONTROLLING_ERFOLGREICH: {
            const a = <GetPrueflaufControllingErfolgreichAction>action;

            let aktuellePruefaufgabe: PrueflaufAufgabe = null;
            if (state.aktuellePruefaufgabe !== null) {
                a.payload.checklisten.forEach(checkliste => {
                    const index = checkliste.aufgaben.findIndex((x) => x.pruefaufgabe_id === state.aktuellePruefaufgabe.pruefaufgabe_id
                    && x.pruefcheckliste_id === state.aktuellePruefaufgabe.pruefcheckliste_id);
                    if (index > -1) {
                        aktuellePruefaufgabe = Object.assign({}, checkliste.aufgaben[index]);
                    }
                });
            }

            return Object.assign({}, state, <PageState>{
                prueflaufDetailLaden: false,
                prueflaufDetailFehler: false,
                prueflaufDetail: a.payload,
                aktuellePruefaufgabe
            });
        }

        case GET_PRUEFLAUF_CONTROLLING_FEHLER: {
            return Object.assign({}, state, <PageState>{
                prueflaufDetailLaden: false,
                prueflaufDetailFehler: true,
                prueflaufDetail: null
            });
        }

        case POST_PRUEFLAUF_LOESCHEN: {
            const a = <PostPrueflaufLoeschenAction>action;
            if (a.prueflaufRequest.prueflauf_id === state.aktuellerPrueflauf.prueflauf_id) {
                return Object.assign({}, state, <PageState>{
                    aktuellerPrueflauf: null,
                    prueflaufDetail: null
                });
            } else {
                return Object.assign({}, state);
            }
        }

        case AKTUELLE_PRUEFAUFGABE_SETZEN: {
            const a = <AktuellePruefaufgabeSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                aktuellePruefaufgabe: a.payload
            });
        }

        default: {
            return state;
        }
    }
}
